module.exports = __webpack_public_path__ + "img/1_3.553b080f.png";